module.exports = __webpack_public_path__ + "img/galleria4.0f917271.jpg";